var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup-notifications"},[_c('transition-group',{attrs:{"name":"notification-slide"}},_vm._l((_vm.notifications),function(notif){return _c('popup-notification',{key:notif.key,attrs:{"identifier":notif.key,"text":notif.content,"action-text":notif.action_message,"action-url":notif.action_url}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }